/*eslint-disable no-unused-vars */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setSearchProviderFilters,
  resetSearchProviderFilters,
  setShowAllFiltersPanel,
} from '../../../../../redux/admin/priceCompareSlice';
import {
  getPriceComaperFilters,
  searchProviders,
} from '../../../../../redux/admin/api-calls/priceCompare';
import AllFilterOptions from './AllFilterOptions';
import './SearchFilter.scss';
import { t } from 'i18next';

const SearchFilter = (props) => {
  const { showAllFiltersPanel } = useSelector(
    (state) => state?.priceCompareAdmin,
  );
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.searchProviderParams?.filters,
  );
  const { Gender, maximumradius, spokenlanguages } = allFilters;
  const filtersValuesList = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin?.filtersValuesList,
  );

  const onChangeHandler = async (paramName, value) => {
    if (paramName !== 'spokenlanguages') {
      dispatch(setSearchProviderFilters({ [paramName]: value }));
    }
    if (paramName === 'spokenlanguages') {
      if (value) {
        const valuesToSave = value.map((val) => {
          return val.value;
        });
        dispatch(setSearchProviderFilters({ spokenlanguages: valuesToSave }));
      } else {
        dispatch(setSearchProviderFilters({ spokenlanguages: null }));
      }
    }
  };

  const applyAllFilters = (selectedOptions) => {
    dispatch(setSearchProviderFilters(selectedOptions));
    dispatch(setShowAllFiltersPanel(false));
  };

  const resetFilters = () => {
    dispatch(resetSearchProviderFilters());
  };

  return (
    <>
      <AllFilterOptions
        isVisible={showAllFiltersPanel}
        onHide={() => {
          dispatch(setShowAllFiltersPanel(false));
        }}
        //filters={allFilters}
        onApply={applyAllFilters}
      />
    </>
  );
};

export default SearchFilter;
